// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomLinkedin = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.75 2.5C3.41921 2.50236 3.10263 2.63481 2.86872 2.86872C2.63481 3.10263 2.50236 3.41921 2.5 3.75V12.25C2.5 12.9335 3.0665 13.5 3.75 13.5H12.25C12.9335 13.5 13.5 12.9335 13.5 12.25V3.75C13.5 3.0665 12.9335 2.5 12.25 2.5H3.75ZM3.75 3.5H12.25C12.3925 3.5 12.5 3.6075 12.5 3.75V12.25C12.5007 12.283 12.4947 12.3158 12.4824 12.3465C12.47 12.3771 12.4516 12.4049 12.4283 12.4283C12.4049 12.4516 12.3771 12.47 12.3465 12.4824C12.3158 12.4947 12.283 12.5007 12.25 12.5H3.75C3.71696 12.5008 3.68412 12.4948 3.65345 12.4825C3.62278 12.4702 3.59492 12.4518 3.57155 12.4285C3.54818 12.4051 3.5298 12.3772 3.5175 12.3466C3.5052 12.3159 3.49925 12.283 3.5 12.25V3.75C3.5 3.6075 3.6075 3.5 3.75 3.5ZM5.219 4.3595C5.10442 4.35674 4.99044 4.37692 4.88377 4.41886C4.77711 4.46079 4.6799 4.52364 4.59789 4.60371C4.51587 4.68377 4.45069 4.77943 4.40619 4.88505C4.36169 4.99068 4.33877 5.10413 4.33877 5.21875C4.33877 5.33337 4.36169 5.44682 4.40619 5.55245C4.45069 5.65807 4.51587 5.75373 4.59789 5.83379C4.6799 5.91386 4.77711 5.97671 4.88377 6.01864C4.99044 6.06058 5.10442 6.08076 5.219 6.078C5.4433 6.07259 5.65659 5.97969 5.81331 5.81913C5.97004 5.65858 6.05777 5.44311 6.05777 5.21875C6.05777 4.99439 5.97004 4.77892 5.81331 4.61837C5.65659 4.45781 5.4433 4.36491 5.219 4.3595ZM9.734 6.6405C9.0175 6.6405 8.541 7.033 8.344 7.406H8.3125V6.75H6.906V11.5H8.375V9.156C8.375 8.537 8.498 7.9375 9.2655 7.9375C10.0215 7.9375 10.0315 8.6365 10.0315 9.1875V11.5H11.5V8.8905C11.5 7.6135 11.228 6.6405 9.734 6.6405ZM4.5 6.75V11.5H5.9845V6.75H4.5Z',
      fill: 'black',
    }),
  );

export { IconCustomLinkedin };
